export default "__VITE_ASSET__a41e0edf__"